import { render } from "./GlobalHead.vue?vue&type=template&id=d8fc6210"
import script from "./GlobalHead.vue?vue&type=script&lang=js"
export * from "./GlobalHead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__